module.exports = __webpack_public_path__ + "img/logo-white.a251e47d.png";